import { createSlice } from "@reduxjs/toolkit";
const reducer = createSlice({
    name: "BusinessDetails",
    initialState: {},
    reducers: {
        AddBusinessDetails(state, action) {
            return state = action.payload;
        },
    },
});
export const { AddBusinessDetails } = reducer.actions;
export default reducer.reducer;